import axios from 'axios';

// Use environment variables to determine the API URL
const baseURL = process.env.REACT_APP_API_URL || 'https://memorylink.onrender.com';

const api = axios.create({
    baseURL,
    withCredentials: true, // Important for cookies/sessions
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add request interceptor for debugging
api.interceptors.request.use(
    config => {
        console.log('API Request:', config);
        return config;
    },
    error => {
        console.error('API Request Error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for debugging
api.interceptors.response.use(
    response => {
        console.log('API Response:', response);
        return response;
    },
    error => {
        console.error('API Response Error:', error.response || error);
        return Promise.reject(error);
    }
);

export default api;